/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.commentModule')
.directive('bulbCommentQuotation', ['$timeout', 'BulbCommentService', bulbCommentQuotation]);

function bulbCommentQuotation($timeout, BulbCommentService) {
  return {
    restrict: 'E',
    templateUrl: 'ajs/components/comment/comment-quotation.html',
    scope: {
      commentThread: '=',
      lowerComment: '='
    },
    link: function(scope, element) {

      scope.maxHeightOver = false;
      scope.expanded = scope.lowerComment ? BulbCommentService.lowerQuotationExpanded : BulbCommentService.sideQuotationExpanded;

      $timeout(function(){
        var h = element.find('span').height();
        var maxHeightOver = h >= 70;
        scope.maxHeightOver = maxHeightOver;
        scope.commentService = BulbCommentService;

        if (maxHeightOver) {
          var thread = scope.commentThread;
          var scrollContainer = element.closest('[bulb-themed-scrollbar]').get(0);
          $(element).on('click', function() {
            $timeout(function() {
              var currentValue = (scope.expanded[thread.id] === true);
              scope.expanded[thread.id] = !currentValue;
              if (!scope.lowerComment) {
                $timeout(function() {
                  window.Ps.update(scrollContainer);
                });
              }
            });
          });
        }
      });
    }
  };
}
